let filterActions = {
    applyFilter: function(data) {
        return (dispatch, getState)=>{
            return new Promise((resolve, reject)=>{
                let currentData = getState().searchFilter;
                const merged = {...currentData, ...data};
                dispatch({type: 'APPLY_FILTER', data:merged});
                resolve(merged);
            });
        };
    }
};

export default filterActions;
